import capitalize from 'lodash/capitalize'

export const getSourceSegmentLabel = (sourceSegment: string) => {
  switch (sourceSegment) {
    case 'dat':
      return 'DAT'
    case 'ds_loads_for_you':
      return 'Intelligent Recommendations'
    case 'lane_alert_dispatcher_created':
      return 'Saved Lane (User Created)'
    case 'lane_alert_cm_created':
      return 'Saved Lane (Rep Created)'
    case 'lane_alert_auto_historical':
      return 'Run it Again'
    case 'lane_alert_carrier_truck_availability':
      return 'Posted Truck'
    case 'my_bids_page':
      return 'My Bids Page'
    case 'organic_shipment_search':
      return 'Organic Search'
    case 'reloads_shipment_search':
      return 'Reloads'
    case 'reloads_post_rate_con_modal':
      return 'Reloads Post Rate Con'
    case 'dat_posting':
      return 'DAT Posting'
    default:
      return sourceSegment
        .split('_')
        .map(n => capitalize(n))
        .join(' ')
  }
}
